module.exports = __webpack_public_path__ + "img/km_02.5f864237.jpeg";